import { ofType } from 'redux-observable';
import { Observable, of } from 'rxjs';
import { catchError, mergeMap, takeUntil, withLatestFrom } from 'rxjs/operators';
import { Weddings } from '@bridebook/models';
import { appError } from '@bridebook/web/lib/app/actions';
import { BudgetActionTypes } from '@bridebook/web/lib/budget/action-types';
import { onFirebaseBudget } from '@bridebook/web/lib/budget/actions/on-listener';
import { Action, IEpicDeps } from '@bridebook/web/lib/types';
import { recursiveOmitMutableTimestamps } from '../utils';
import { recursiveSerializeTimestamps } from '@bridebook/toolbox/src/serialize-timestamps';

export const initBudgetListener = (action$: Observable<Action>, { state$ }: IEpicDeps) =>
  action$.pipe(
    ofType(BudgetActionTypes.INIT_LISTENER),
    withLatestFrom(state$),
    mergeMap(([, state]) => {
      const weddingId = state.weddings.profile.id;

      const costs$ = Weddings._.getById(weddingId).Costs.query().observe();

      return costs$.pipe(
        mergeMap((costs) =>
          of(onFirebaseBudget(recursiveOmitMutableTimestamps(recursiveSerializeTimestamps(costs)))),
        ),
        takeUntil(action$.pipe(ofType(BudgetActionTypes.STOP_LISTENER))),
        // Without this an error took the whole root epic down with it. The failure is also
        // recorded: `listenerInitialised` never arrives after this, and a reader waiting on
        // it has no other way to tell that from still loading.
        catchError((error: Error) =>
          of(appError({ error, feature: 'Budget Listener' }), {
            type: BudgetActionTypes.LISTENER_FAILED,
          }),
        ),
      );
    }),
  );
